var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings-page-v2" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.settings") }],
          "show-trial-remain-day": true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-page-v2-wrapper" },
        [
          _c("SettingsMenu", {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
          _vm._v(" "),
          _vm.settingInitialized
            ? _c(
                "div",
                { staticClass: "page-content" },
                [
                  _vm.tab === "company"
                    ? _c("Company", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "features"
                    ? _c("Features", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "language"
                    ? _c("Language", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "bubble-settings"
                    ? _c("BubbleSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "bubble-actions"
                    ? _c("BubbleActions", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "theme-settings"
                    ? _c("ChatThemeSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "timing_settings"
                    ? _c("ChatTimingSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "visitorLoginForm"
                    ? _c("VisitorLoginForm", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "availability"
                    ? _c("Availability", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "website-integration"
                    ? _c("WebSiteIntegration", {
                        staticClass: "website-integrations",
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "developer"
                    ? _c("ApiAccess", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "visitorAttribute"
                    ? _c("VisitorAttribute")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "auto_assign"
                    ? _c("AutoChatAssign", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "wallet"
                    ? _c("Wallet", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === "notifications"
                    ? _c("NotificationSettings", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tab === _vm.SettingsMenuTypes.AUDIT_LOGS.id
                    ? _c("AuditLogs", {
                        attrs: { "update-settings": _vm.updateSingleSettings },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }